import React from "react";
import Tabla from "./Tabla";

function TrackingLinks(props) {
  return <Tabla {...props} />;
}

export default TrackingLinks;
